import type { FC } from "react";
import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { translate } from "app/filters/i18nFilter";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";

import { SearchOverviewTexts } from "../../../../texts";
import type { SearchRankPositionData } from "../../types";
import CompoundWidget from "../CompoundWidget/CompoundWidget";

import { BodyWrapper, GreyCaptionText } from "./styledComponents";

interface RankPositionWidgetProps {
    data: SearchRankPositionData;
    descriptionText: string;
}
const RankPositionWidget: FC<RankPositionWidgetProps> = ({ data, descriptionText }) => {
    const { params } = useCurrentStateAndParams();
    const { duration } = params;

    const countryName = data?.country && CountryService.getCountryById(data.country).text;

    const durationObject = useMemo(() => DurationService.getDurationData(duration), [duration]);

    const lastMonth = durationObject.raw.to.format("MMM YYYY");
    return (
        <CompoundWidget>
            <CompoundWidget.Body
                data={data}
                descriptionText={descriptionText}
                granularityText={translate(SearchOverviewTexts.mom)}
            >
                <BodyWrapper />
            </CompoundWidget.Body>
            <CompoundWidget.Footer>
                {countryName ? (
                    <GreyCaptionText>
                        {lastMonth}, {countryName}
                    </GreyCaptionText>
                ) : null}
            </CompoundWidget.Footer>
        </CompoundWidget>
    );
};

export default RankPositionWidget;
